import { render } from "./KaimonoListComp.vue?vue&type=template&id=62978c66&scoped=true"
import script from "./KaimonoListComp.vue?vue&type=script&lang=js"
export * from "./KaimonoListComp.vue?vue&type=script&lang=js"

import "./KaimonoListComp.vue?vue&type=style&index=0&id=62978c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62978c66"]])

export default __exports__